import { Injectable } from '@angular/core';

export type SignupVariant = 'original' | 'redesign';
export type SignupVariantSource = 'assigned' | 'forced' | 'none';

@Injectable({ providedIn: 'root' })
export class VariantService {
  readonly variant: SignupVariant = readAssignedVariant();
  readonly source: SignupVariantSource = readVariantSource();

  get isRedesign(): boolean {
    return this.variant === 'redesign';
  }
}

function readAssignedVariant(): SignupVariant {
  const assigned = (globalThis as { __signupVariant?: unknown }).__signupVariant;
  return assigned === 'redesign' ? 'redesign' : 'original';
}

function readVariantSource(): SignupVariantSource {
  const source = (globalThis as { __signupVariantSource?: unknown }).__signupVariantSource;
  return source === 'assigned' || source === 'forced' ? source : 'none';
}
